module.exports = __webpack_public_path__ + "static/media/365.61e71f70.webp";